import React, { FC } from 'react';

interface IProps {
  className?: string;
  onClick?: () => void;
}

export const ArrowLeftRoundedIcon: FC<IProps> = ({ className, onClick }) => (
  <svg
    width='40'
    height='41'
    viewBox='0 0 40 41'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    className={className}
    onClick={onClick}
  >
    <path
      d='M22 26.28C21.8734 26.28 21.7467 26.2333 21.6467 26.1333L17.3 21.7867C16.5934 21.08 16.5934 19.92 17.3 19.2133L21.6467 14.8667C21.84 14.6733 22.16 14.6733 22.3534 14.8667C22.5467 15.06 22.5467 15.38 22.3534 15.5733L18.0067 19.92C17.6867 20.24 17.6867 20.76 18.0067 21.08L22.3534 25.4267C22.5467 25.62 22.5467 25.94 22.3534 26.1333C22.2534 26.2267 22.1267 26.28 22 26.28Z'
      fill='#59637D'
    />
    <rect x='0.5' y='1' width='39' height='39' rx='19.5' stroke='#BDC5DB' />
  </svg>
);
